import { setTheme } from "theme/default/setTheme";

export const color_f6b57a = setTheme(({ theme }) => theme.colors.color_f6b57a);
